export enum EInputTypes {
  Text = 'text',
  Email = 'email',
  EmailIcon = 'email-icon',
  Password = 'password',
  Radio = 'radio',
}
